import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DevicePresenceService, presenceLabel } from '../../services/device-presence.service';

/** "via <gateway> · ● Online | Offline for N min" under a camera name; nothing for a camera with no gateway. */
@Component({
  selector: 'urban-gateway-reach',
  template: `
    @if (state()?.gatewayName && label(); as l) {
      <span class="captionText secondaryTextColor gatewayReach">
        {{ 'VIDEO_STATUS.VIA_GATEWAY' | translate: { name: state()?.gatewayName } }}
        <span aria-hidden="true">·</span>
        <span class="uvPresenceDot" [attr.data-presence]="state()?.presence"></span>
        {{ l.key | translate: { count: l.count } }}
      </span>
    }
  `,
  styles: [`
    :host { display: block; min-width: 0; }
    .gatewayReach { display: inline-flex; align-items: center; gap: 6px; max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  `],
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GatewayReachComponent {
  public readonly deviceId = input<string | null | undefined>(null);

  private readonly service = inject(DevicePresenceService);

  protected readonly state = toSignal(
    toObservable(this.deviceId).pipe(
      distinctUntilChanged(),
      switchMap(id => this.service.watch(id))
    )
  );

  protected readonly label = computed(() => {
    const state = this.state();
    return state ? presenceLabel(state) : null;
  });
}
